import { isSystemIcon, systemIcons } from './sds-icon.system';

export type IconPromise = (iconName: string) => Promise<string>;

const loadLocalIcons: IconPromise = (name: string) =>
	import(`@politiet/sheriff-icons/dist/assets/${name}.js`)
		.then(({ default: svg }) => {
			return svg;
		})
		.catch((error) => {
			console.log(error);
		});

const loadCdnIcons: IconPromise = (name: string) =>
	fetch(`https://cdn.jsdelivr.net/npm/@politiet/sheriff-icons/dist/assets/${name}.svg`).then((response) => {
		if (!response.ok) {
			throw new TypeError(`Sheriff: unknown icon: '${name}'`);
		}
		return response.text();
	});

export class SDSIconLoader {
	private cache = new Map<string, string | Promise<string>>();
	private _loadLocal: boolean = false;
	private _disableSystemIcons: boolean = false;

	get loadLocal(): boolean {
		return this._loadLocal;
	}

	set loadLocal(value: boolean) {
		this._loadLocal = value;
		this.resolver = value ? loadLocalIcons : loadCdnIcons;
	}

	set disableSystemIcons(value: boolean) {
		this._disableSystemIcons = value;
	}

	resolver: IconPromise = this._loadLocal ? loadLocalIcons : loadCdnIcons;

	resolve(name: string, onResolved: (svg: string) => void): void {
		if (!this._disableSystemIcons && isSystemIcon(name)) {
			onResolved(systemIcons[name]);
			return;
		}

		let cached = this.cache.get(name);

		if (typeof cached === 'string') {
			onResolved(cached);
			return;
		}

		if (!cached) {
			cached = this.resolver(name)
				.catch(() => '')
				.then((svg) => {
					this.cache.set(name, svg);
					return svg;
				});

			this.cache.set(name, cached);
		}

		cached.then(onResolved);
	}

	clear(): void {
		this.cache.clear();
	}

	get currentLoader(): IconPromise {
		return this.resolver;
	}
}
